export default {
  en: {
    dayparts: 'Dayparts',
    daypart: 'Daypart',
    'daypart-breakfast': 'Breakfast',
    'daypart-dinner': 'Dinner',
    'daypart-evening': 'Evening',
    'daypart-lunch': 'Lunch',
    'daypart-snack': 'Snack',
    'daypart-late_night': 'Late Night',
    peak: 'Peak',
    timeslice: 'Timeslice',
    peaks: 'Peaks',
    timeslices: 'Timeslices',
    'time-slices': 'Time Slices',
    'my-time-slices': 'My Time Slices',
    'time-slice-time': 'Time',
    scope: 'Scope',
    'scope-enterprise': 'Enterprise',
    'scope-org': 'Organization',
    'scope-user': 'Personal',
    // Create / edit form. The type is interpolated so the action names what is
    // actually being created: "Create Daypart", "Create Peak", ...
    'create-type': 'Create {type}',
    'update-type': 'Update {type}',
    'delete-type': 'Delete {type}',
    // Names the record rather than using a demonstrative, which avoids
    // grammatical gender agreement in translated locales.
    'delete-type-confirm':
      'Are you sure you want to delete "{name}"? This action cannot be undone.',
    'time-slice-type': 'Type',
    'time-slice-scope-question': 'Who is this timeslice for?',
    'scope-just-me': 'Just for me',
    'scope-all-of': 'All of {name}',
    'next-day-warning': 'This timeslice extends into the next day.',
    'no-time-slices': 'No time slices yet.',
    // Validation
    'name-already-exists': 'A {type} with this name already exists',
    'name-no-time-suffix': 'Names cannot end with a time range in parentheses',
    'name-no-type-prefix':
      'Names cannot start with "Daypart-", "Peak-", or "Timeslice-"',
    'name-too-long': 'Names are limited to {max} characters',
    'select-start-end': 'Select a start and end time',
    // Outcomes
    'time-slice-saved': 'Time slice saved.',
    'time-slice-deleted': 'Time slice deleted.',
    'time-slice-load-error': 'Could not load time slices.',
    'time-slice-load-partial-error':
      'Some time slices could not be loaded, so this list may be incomplete.',
    'time-slice-save-error': 'Could not save the time slice.',
    'time-slice-delete-error': 'Could not delete the time slice.',
    // Directs the user to Edit, not to the (now blank) create form — saving
    // there again would add a duplicate rather than repair the missing half.
    'time-slice-twin-warning':
      'Saved, but the matching next-day entry failed. Edit this time slice and save it again to repair.',
    'scope-not-editable': 'You do not have permission to change this time slice',
  },
  es: {
    dayparts: 'Partes del día',
    daypart: 'Parte del día',
    'daypart-breakfast': 'Desayuno',
    'daypart-dinner': 'Cena',
    'daypart-evening': 'Noche',
    'daypart-lunch': 'Almuerzo',
    'daypart-snack': 'Merienda',
    'daypart-late_night': 'Madrugada',
    peak: 'Pico',
    timeslice: 'Franja horaria',
    peaks: 'Picos',
    timeslices: 'Franjas Horarias',
    'time-slices': 'Franjas Horarias',
    'my-time-slices': 'Mis franjas horarias',
    'time-slice-time': 'Hora',
    scope: 'Alcance',
    'scope-enterprise': 'Empresa',
    'scope-org': 'Organización',
    'scope-user': 'Personal',
    // Create / edit form
    'create-type': 'Crear {type}',
    'update-type': 'Actualizar {type}',
    'delete-type': 'Eliminar {type}',
    'delete-type-confirm':
      '¿Está seguro de que desea eliminar "{name}"? Esta acción no se puede deshacer.',
    'time-slice-type': 'Tipo',
    'time-slice-scope-question': '¿Para quién es esta franja horaria?',
    'scope-just-me': 'Sólo para mí',
    'scope-all-of': 'Todo {name}',
    'next-day-warning': 'Esta franja horaria se extiende al día siguiente.',
    'no-time-slices': 'Aún no hay franjas horarias.',
    // Validation
    'name-already-exists': 'Ya existe un {type} con este nombre',
    'name-no-time-suffix':
      'Los nombres no pueden terminar con un intervalo de horas entre paréntesis',
    'name-no-type-prefix':
      'Los nombres no pueden comenzar con "Daypart-", "Peak-" ni "Timeslice-"',
    'name-too-long': 'Los nombres están limitados a {max} caracteres',
    'select-start-end': 'Seleccione una hora de inicio y de fin',
    // Outcomes
    'time-slice-saved': 'Franja horaria guardada.',
    'time-slice-deleted': 'Franja horaria eliminada.',
    'time-slice-load-error': 'No se pudieron cargar las franjas horarias.',
    'time-slice-load-partial-error':
      'Algunas franjas horarias no se pudieron cargar, por lo que esta lista puede estar incompleta.',
    'time-slice-save-error': 'No se pudo guardar la franja horaria.',
    'time-slice-delete-error': 'No se pudo eliminar la franja horaria.',
    'time-slice-twin-warning':
      'Guardada, pero la entrada del día siguiente falló. Edite esta franja horaria y guárdela de nuevo para repararla.',
    'scope-not-editable': 'No tiene permiso para modificar esta franja horaria',
  },
  fr: {
    dayparts: 'Périodes de la journée',
    daypart: 'Période de la journée',
    'daypart-breakfast': 'Petit-déjeuner',
    'daypart-dinner': 'Dîner',
    'daypart-evening': 'Soirée',
    'daypart-lunch': 'Déjeuner',
    'daypart-snack': 'Collation',
    'daypart-late_night': 'Fin de soirée',
    peak: 'Pointe',
    timeslice: 'Plage horaire',
    peaks: 'Pointes',
    'time-slices': 'Plages horaires',
    'my-time-slices': 'Mes plages horaires',
    'time-slice-time': 'Heure',
    scope: 'Portée',
    'scope-enterprise': 'Entreprise',
    'scope-org': 'Organisation',
    'scope-user': 'Personnel',
    // Create / edit form
    'create-type': 'Créer {type}',
    'update-type': 'Modifier {type}',
    'delete-type': 'Supprimer {type}',
    'delete-type-confirm':
      'Voulez-vous vraiment supprimer « {name} » ? Cette action est irréversible.',
    'time-slice-type': 'Type',
    'time-slice-scope-question': 'À qui destinez-vous cette plage horaire ?',
    'scope-just-me': 'Seulement pour moi',
    'scope-all-of': 'Tout {name}',
    'next-day-warning': 'Cette plage horaire se prolonge au jour suivant.',
    'no-time-slices': 'Aucune plage horaire pour l’instant.',
    // Validation
    'name-already-exists': 'Ce nom existe déjà pour : {type}',
    'name-no-time-suffix':
      'Un nom ne peut pas se terminer par une plage horaire entre parenthèses',
    'name-no-type-prefix':
      'Un nom ne peut pas commencer par « Daypart- », « Peak- » ou « Timeslice- »',
    'name-too-long': 'Les noms sont limités à {max} caractères',
    'select-start-end': 'Sélectionnez une heure de début et de fin',
    // Outcomes
    'time-slice-saved': 'Plage horaire enregistrée.',
    'time-slice-deleted': 'Plage horaire supprimée.',
    'time-slice-load-error': 'Impossible de charger les plages horaires.',
    'time-slice-load-partial-error':
      'Certaines plages horaires n’ont pas pu être chargées. Cette liste peut être incomplète.',
    'time-slice-save-error': 'Impossible d’enregistrer la plage horaire.',
    'time-slice-delete-error': 'Impossible de supprimer la plage horaire.',
    'time-slice-twin-warning':
      'Enregistrée, mais l’entrée du jour suivant a échoué. Modifiez cette plage horaire et enregistrez-la de nouveau pour la réparer.',
    'scope-not-editable':
      'Vous n’avez pas la permission de modifier cette plage horaire',
  },
  // Québec meal names differ from France: breakfast/lunch/dinner are
  // déjeuner/dîner/souper here, not petit-déjeuner/déjeuner/dîner.
  'fr-ca': {
    dayparts: 'Périodes de la journée',
    daypart: 'Période de la journée',
    'daypart-breakfast': 'Déjeuner',
    'daypart-dinner': 'Souper',
    'daypart-evening': 'Soirée',
    'daypart-lunch': 'Dîner',
    'daypart-snack': 'Collation',
    'daypart-late_night': 'Fin de soirée',
    peak: 'Période de pointe',
    timeslice: 'Plage horaire',
    peaks: 'Périodes de pointe',
    'time-slices': 'Plages horaires',
    'my-time-slices': 'Mes plages horaires',
    'time-slice-time': 'Heure',
    scope: 'Portée',
    'scope-enterprise': 'Entreprise',
    'scope-org': 'Organisation',
    'scope-user': 'Personnel',
    // Create / edit form. Québec typography omits the space before ? and !,
    // which is the only difference from the fr block above.
    'create-type': 'Créer {type}',
    'update-type': 'Modifier {type}',
    'delete-type': 'Supprimer {type}',
    'delete-type-confirm':
      'Voulez-vous vraiment supprimer « {name} »? Cette action est irréversible.',
    'time-slice-type': 'Type',
    'time-slice-scope-question': 'À qui destinez-vous cette plage horaire?',
    'scope-just-me': 'Seulement pour moi',
    'scope-all-of': 'Tout {name}',
    'next-day-warning': 'Cette plage horaire se prolonge au jour suivant.',
    'no-time-slices': 'Aucune plage horaire pour l’instant.',
    // Validation
    'name-already-exists': 'Ce nom existe déjà pour : {type}',
    'name-no-time-suffix':
      'Un nom ne peut pas se terminer par une plage horaire entre parenthèses',
    'name-no-type-prefix':
      'Un nom ne peut pas commencer par « Daypart- », « Peak- » ou « Timeslice- »',
    'name-too-long': 'Les noms sont limités à {max} caractères',
    'select-start-end': 'Sélectionnez une heure de début et de fin',
    // Outcomes
    'time-slice-saved': 'Plage horaire enregistrée.',
    'time-slice-deleted': 'Plage horaire supprimée.',
    'time-slice-load-error': 'Impossible de charger les plages horaires.',
    'time-slice-load-partial-error':
      'Certaines plages horaires n’ont pas pu être chargées. Cette liste peut être incomplète.',
    'time-slice-save-error': 'Impossible d’enregistrer la plage horaire.',
    'time-slice-delete-error': 'Impossible de supprimer la plage horaire.',
    'time-slice-twin-warning':
      'Enregistrée, mais l’entrée du jour suivant a échoué. Modifiez cette plage horaire et enregistrez-la de nouveau pour la réparer.',
    'scope-not-editable':
      'Vous n’avez pas la permission de modifier cette plage horaire',
  },
};
